import { LegalPage, MailLink } from "./LegalPage";

/**
 * Privacy Policy, verbatim from the Google Doc 1nFQbRY07R6N9JtZNfvEY1qk_czRSQfFuwAH8MYpRMDs.
 * Formatting only: section titles are headings (including "Personal Information Acquired for
 * Financial Planning…", which the export ran into the "Internet" paragraph), long sections are
 * split at sentence boundaries, and the email address is a link.
 */
export function PrivacyPage() {
  return (
    <LegalPage slug="privacy" title="Privacy Policy">
      <h2>Personal Information</h2>
      <p>
        WealthyPlanet does not collect personal information beyond the &ldquo;Update My Data&rdquo;
        page of the app. If you ever receive an email appearing to come from us asking for personal
        information, disregard it. This may be a practice called phishing, and it is illegal. All
        data is stored in an encrypted format. Users may request to have their data deleted from our
        database at any point by sending an email request to <MailLink />.
      </p>

      <h2>Emails</h2>
      <p>
        Customers may receive unsolicited emails from WealthyPlanet if we have an e-mail address on
        file as you have filled out a confidential financial plan with us; or signed up on our
        website to receive our newsletters or notifications on new product/service announcements, or
        have engaged with us via a participating in a confidential survey. These emails occur only
        periodically when we issue a newsletter or have important information about our software or
        products to communicate. If you do not wish to receive these emails from us, you can
        unsubscribe via the information located at the bottom of our company email/newsletter.
        Alternatively, you can contact us via email at the end of this document. For emails, we
        operate in full alignment with Canada&rsquo;s Anti-Spam Law (CASL).
      </p>

      <h2>Links to Other Websites</h2>
      <p>
        Our website may provide links to other sites which have their own policies regarding
        privacy. It is always best to review the Privacy Policies of any site when providing
        personal information.
      </p>

      <h2>Internet</h2>
      <p>
        We use services such as Google Analytics, and other similar programs to better understand
        WealthyPlanet&rsquo;s website traffic. We use this information for internal purposes only
        and in full alignment with Canada&rsquo;s Anti-Spam Law (CASL).
      </p>

      <h2>
        Personal Information Acquired for Financial Planning or Transaction Purposes or through
        Participating in a Survey
      </h2>
      <p>
        Personal information that we receive from customers is proprietary and is strictly
        required/used for your financial planning purposes, or for a product/service transaction
        authorized by you only. We will never sell or transfer any personal information to another
        third party outside the bounds of a customer or financial planning user agreement. The
        parties directly involved in expediting any customer agreement for purchasing a service,
        such as lawyers, brokers, and third-party financial service providers are exempt and receive
        information about you as requested by you or on an as-needed basis.
      </p>
      <p>
        The security level of any confidential information is based on its sensitivity and includes
        password protection and restricted access. Only employees that require this information in
        the course of day-to-day business operations are allowed access. We provide training to
        employees on the confidentiality of any client&apos;s personal information or other personal
        information we may collect and require all employees to sign non-disclosure agreements.
      </p>
      <p>
        In the case of surveys, we may communicate the aggregate summary of the survey results. All
        other information from survey responders is kept private and confidential. WealthyPlanet
        may, however, disclose information when we believe disclosure is necessary to comply with
        the law.
      </p>

      <h2>Disposal of Personal Information</h2>
      <p>
        Personal information that is no longer required is always destroyed or shredded. Any hard
        drives are erased before they are disposed of. For accounting purposes, by law, we need to
        keep information regarding some business transactions for seven years such as in the case of
        purchasing a financial product from us.
      </p>

      <h2>Physical Security of WealthyPlanet Premises</h2>
      <p>
        All of our offices have building security and/or are securely locked after hours. Any hard
        copy records are similarly protected by lock and key. Computer room facilities/servers are
        accessible only by certain management and IT staff. WealthyPlanet networks are secured by
        firewalls. This software is kept current to protect our files, operating systems, and
        software.
      </p>

      <h2>Changes to our Privacy Policy</h2>
      <p>
        WealthyPlanet reserves the right to modify this Privacy Policy at any time and we will post
        such changes on our website accordingly. If you have any questions or concerns regarding
        WealthyPlanet&rsquo;s Privacy Policy, please contact us <MailLink />
      </p>
    </LegalPage>
  );
}
